// polyfills
import "intl";
import "intl/locale-data/jsonp/ru"; // end polyfills

import RegistrationPopup from "scripts/dom_utils/popups/registration_popup";
import LoginPopup from "scripts/dom_utils/popups/login_popup";
import PasswordResetPopup from "scripts/dom_utils/popups/password_reset_popup";
import initGlobalMenu, { initMobileNavigationDrawer } from "scripts/dom_utils/open_close_menu";
import "scripts/dom_utils/block_button_on_submit";
import initMessageClose from "scripts/dom_utils/close_message_box";
import resizableTextareaHandler from "scripts/dom_utils/resizable_textarea_handler";
import { qsAll } from "scripts/data_utils/domHelpers";
import { sendYaMetricksEvent } from "scripts/utils/sendYaMetricksEvent";
import { logEvent } from "scripts/utils/amplitude";
import { hasUrlParameter, removeUrlParameters } from "scripts/utils/urlParameter";
import { apiGetUserSession } from "scripts/constants/api";
import { initSentry } from "scripts/data_utils/initSentry";
import { renderOfferModal } from "scripts/bundles/GlobalModals";
import { getNotificationsCounter } from "scripts/dom_utils/notification";

if (!window.Promise) {
  window.Promise = Promise;
}

document.addEventListener("DOMContentLoaded", async () => {
  const response = await fetch(apiGetUserSession);
  const {
    result: userRawData
  } = await response.json();
  const {
    email,
    id: userId,
    tracking_id: trackingId,
    is_offer_agreement_accepted: isUserAcceptNewOffer
  } = userRawData;

  const _isUserAuthorize = !!parseInt(userRawData.id, 10);

  if (_isUserAuthorize && !isUserAcceptNewOffer) {
    renderOfferModal(isUserAcceptNewOffer);
  }

  try {
    const user = {
      email,
      id: userId,
      trackingId,
      isAuthorize: _isUserAuthorize
    };
    localStorage.setItem("user", JSON.stringify(user));
  } catch (error) {
    // Log event to sentry without break execution
    // eslint-disable-next-line no-console
    console.error("Error writing user object to localstorage");
  }

  if (_isUserAuthorize) {
    initGlobalMenu(userRawData);
  } else {
    document.body.addEventListener("click", e => {
      const {
        target
      } = e;

      if (target.classList.contains("js-show-registration-popup")) {
        var _document$querySelect, _document$querySelect2, _document$querySelect3, _document$querySelect4;

        sendYaMetricksEvent("start_registration_click");
        const email = (_document$querySelect = (_document$querySelect2 = document.querySelector(".js-email")) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.value) !== null && _document$querySelect !== void 0 ? _document$querySelect : "";
        const password = (_document$querySelect3 = (_document$querySelect4 = document.querySelector(".js-password")) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.value) !== null && _document$querySelect3 !== void 0 ? _document$querySelect3 : "";
        new RegistrationPopup(target, {
          email,
          password
        });
      }

      if (target.classList.contains("js-show-login-popup")) {
        var _document$querySelect5, _document$querySelect6, _document$querySelect7, _document$querySelect8;

        const email = (_document$querySelect5 = (_document$querySelect6 = document.querySelector(".js-email")) === null || _document$querySelect6 === void 0 ? void 0 : _document$querySelect6.value) !== null && _document$querySelect5 !== void 0 ? _document$querySelect5 : "";
        const password = (_document$querySelect7 = (_document$querySelect8 = document.querySelector(".js-password")) === null || _document$querySelect8 === void 0 ? void 0 : _document$querySelect8.value) !== null && _document$querySelect7 !== void 0 ? _document$querySelect7 : "";
        new LoginPopup(target, {
          email,
          password
        });
      }

      if (target.classList.contains("js-show-password-reset-popup")) {
        var _document$querySelect9, _document$querySelect10;

        const email = (_document$querySelect9 = (_document$querySelect10 = document.querySelector(".js-email")) === null || _document$querySelect10 === void 0 ? void 0 : _document$querySelect10.value) !== null && _document$querySelect9 !== void 0 ? _document$querySelect9 : "";
        new PasswordResetPopup(target, {
          email
        });
      }
    });
  }

  initMobileNavigationDrawer();
  initMessageClose();

  if (_isUserAuthorize) {
    getNotificationsCounter();
  }

  qsAll(".js-resizable-textarea").map(el => el.addEventListener("keyup", resizableTextareaHandler));
  const isEmailConfirmed = hasUrlParameter("email_activated");

  if (isEmailConfirmed) {
    removeUrlParameters(["email_activated"]);

    if (window.__ANALYTICS_ENABLE__) {
      sendYaMetricksEvent("confirm");
      logEvent("onbRegisterConfirm", {
        type: "promotion"
      });
    }
  }

  initSentry({
    email,
    trackingId
  });
});